import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScrollPreventService {
  constructor() {}

  applyScrollPrevent(element: HTMLElement): void {
    if(!element) return;
    element.addEventListener('wheel', this.preventScroll.bind(this), { passive: false });
    element.addEventListener('touchmove', this.preventScroll.bind(this), { passive: false });
  }

  removeScrollPrevent(element: HTMLElement): void {
    if(!element) return;
    element.removeEventListener('wheel', this.preventScroll.bind(this));
    element.removeEventListener('touchmove', this.preventScroll.bind(this));
  }

  private preventScroll(event: WheelEvent | TouchEvent): void {
    const element = event.currentTarget as HTMLElement;

    const scrollTop = element.scrollTop;
    const scrollHeight = element.scrollHeight;
    const clientHeight = element.clientHeight;

    const deltaY = 'deltaY' in event ? (event as WheelEvent).deltaY : 0;

    if ((scrollTop === 0 && deltaY < 0) || (scrollTop + clientHeight >= scrollHeight && deltaY > 0)) {
      event.preventDefault();
    }
  }
}